import { atom, useAtomValue } from 'jotai';
import type { CompanyConfiguration } from 'shared/hooks/use-load-company-configuration';

// @ts-expect-error Escape the typing because it is an invariant; The only place it can be breached
// is in the PrivateLoader which is responsible for enforcing it by leaving the app on the loading
// screen as long as company !== null is not satisfied
export const companyConfigurationAtom = atom<CompanyConfiguration>(null);
companyConfigurationAtom.debugLabel = 'Company Configuration';

export const useCompanyConfiguration = () => useAtomValue(companyConfigurationAtom);
export const usePackage = () => useAtomValue(companyConfigurationAtom).package;

export const hasPontoBankingAccounts = (company: CompanyConfiguration) =>
  company.banking_method === 'ponto' &&
  company.bank_accounts.some(bankAccount => bankAccount.type === 'PontoBankAccount');

export const hasCodaboxBankingAccounts = (company: CompanyConfiguration) =>
  company.banking_method === 'codabox' &&
  company.bank_accounts.some(bankAccount => bankAccount.type === 'CodaboxBankAccount');
